<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/95uvCI/media/FC-9781649791993.jpg?1685203786860" alt="This image is the cover for the book Gone but Not Forgotten"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gone but Not Forgotten
      </h1>
      <p class="bookDescription body article font2">
        <p>Gone but Not Forgotten is the first of a historical fiction trilogy set in America and Europe from 1914 to 1918. It chronicles the tale of the Gilded Age of pageantry through the end of the Great War. It is the story of the Champions, the Wagners and the Sterns, an epical saga of their lives, trials, and tribulations. The story opens at an outdoor wedding in fashionable Newport, Rhode Island. The heroines are beautiful twin sisters, Veda and Rose Champion. Veda is the spoiled American debutante with an iron will. Rose is the gentler beauty and is passively strong. Hans Wagner, the male protagonist, is a German immigrant who comes to America with the quest to live his dream. His best Jewish friend, Rudolph Stern, also arrives from Germany to study medicine. The toils of the Great War halt the hopes of both while ushering in a series of tragedies for the Champion family, including the sinking of the Lusitania, the death of the twins’ brother, Marius Champion, on the battlefields of France, and the vicious murder of their grandparents in Verdon. The novel will be followed by two others, spanning 1918–2000. The trilogy is a portrait of the most significant events in the twentieth century.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gary M. Williams
      </h2>
      
      <p class="authorDescription body article">Gary M. Williams was born and raised in Staten Island, New York. He was a teacher and principal with the New York City Department of Education for thirty-five years. He is currently retired and resides in Manhattan and is now assuming a full-time career in writing. He was inspired to write a historical fictional novel spanning the twentieth century after visits to Newport, Rhode Island, and Europe. After two years of research and eight years of writing, Gone but Not Forgotten, the first of a trilogy, along with the second and third books, reached their completion. In addition to writing, Mr. Williams holds a strong avocation for the arts. His hobbies include theater, reading, and world travel. He is currently working on his next novel and anticipates adding it to his literary repertoire.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?21bf771e